import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    meta: { title: '登录页面' },
    component: () => import('../views/login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    meta: { title: '注册' },
    component: () => import('../views/register.vue'),
  },
  {
    path: '/home',
    component: HomeView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'home',
        meta: { title: '首页' },
        component: () => import('../views/defautPage.vue'),
      },
      {
        path: 'centre',
        component: () => import('../views/centreView.vue'),
        children: [
          {
            path: '',
            name: 'dashboard',
            meta: { title: '控制台' },
            component: () => import('../components/dashboard.vue'),
          },
          {
            path: 'category',
            name: 'category',
            meta: { title: '分类管理' },
            component: () => import('../views/category.vue'),
          },
          {
            path: 'product',
            name: '',
            meta: { title: '商品管理' },
            component: () => import('../views/product.vue'),
            children: [
              {
                path: '',
                name: 'productList',
                meta: { title: '商品列表' },
                component: () => import('../views/productList.vue'),
              },
              {
                path: 'productUpload',
                name: 'productUpload',
                meta: { title: '上传商品' },
                component: () => import('../views/productUpload.vue'),
              },
            ],
          },
          {
            path: 'new',
            name: 'new',
            meta: { title: '新闻管理中心' },
            component: () => import('../views/newView.vue'),
          },
        ],
      },
      {
        path: 'about',
        name: 'about',
        meta: { title: '关于我们' },
        component: () => import('../views/AboutView.vue'),
      },
    ],
  },
  { path: '*', redirect: '/' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// ========================== 路由守卫 + 自动切换标题 ==========================
router.beforeEach((to, from, next) => {
  const hasToken = localStorage.getItem('infoToken');

  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 白名单：登录、注册直接放行
  if (to.path === '/' || to.path === '/register') {
    return next();
  }

  // 没有 token 跳回登录
  if (!hasToken) {
    return next('/');
  }

  next();
});

export default router;
